export const translations = {
  sq: {
    seo: {
      home: {
        title: 'Agjenci Profesionale e Marketingut Dixhital',
        description: 'Contenta Marketing - Transformojmë idetë tuaja në strategji dixhitale që sjellin rezultate. Web Development, Social Media, Content Creation dhe Logo Design në Shqipëri.',
        keywords: 'marketing dixhital, social media marketing, web development, content creation, logo design, agjenci marketingu, shqiperi, albania'
      },
      about: {
        title: 'Rreth Nesh - Historia Jonë',
        description: 'Njihuni me Contenta Marketing - agjencia e re e marketingut dixhital e nisur në 2026 që sjell freski dhe profesionalizëm në tregun shqiptar.',
        keywords: 'rreth nesh, contenta marketing, agjenci marketingu, shqiperi, marketing profesional'
      },
      services: {
        title: 'Shërbimet Tona',
        description: 'Ofrojmë Web Development, Social Media Management, Content Creation dhe Logo Design. Zgjidhje profesionale për biznesin tuaj dixhital.',
        keywords: 'web development, social media management, content creation, logo design, sherbime marketingu, dizajn grafik'
      },
      portfolio: {
        title: 'Portfolio - Projektet Tona',
        description: 'Shikoni projektet tona të suksesshme. Website dhe kampanja dixhitale që kemi krijuar për klientët tanë.',
        keywords: 'portfolio, projekte web, website, web design, dizajn web'
      },
      blog: {
        title: 'Blog - Artikuj dhe Këshilla',
        description: 'Lexoni artikujt tanë për marketing dixhital, social media, SEO dhe strategji të rritjes së biznesit.',
        keywords: 'blog marketing, artikuj marketingu, keshilla social media, seo tips, strategji biznesi'
      },
      contact: {
        title: 'Na Kontaktoni',
        description: 'Merrni kontakt me Contenta Marketing për konsultim falas. WhatsApp, Email ose telefon - ne jemi këtu për t\'ju ndihmuar.',
        keywords: 'kontakt, konsultim falas, contenta marketing shqiperi, telefon, email, whatsapp'
      }
    },
    nav: {
      home: 'Kreu',
      about: 'Rreth Nesh',
      services: 'Shërbimet',
      portfolio: 'Portfolio',
      blog: 'Blog',
      contact: 'Kontakt',
      getStarted: 'Fillo Tani'
    },
    hero: {
      title: 'Transformojmë',
      titleHighlight: 'Idetë Tuaja',
      subtitle: 'në Strategji Dixhitale që Sjellin Rezultate',
      description: 'Agjencia juaj e marketingut dixhital që kombinon kreativitetin me analizën e të dhënave për të rritur markën tuaj në tregun shqiptar dhe ndërkombëtar.',
      cta: 'Konsultim Falas',
      learnMore: 'Shiko Shërbimet',
      stats: {
        projects: 'Projekte të Suksesshme',
        clients: 'Klientë të Kënaqur',
        growth: 'Rritje Mesatare',
        experience: 'Vite Eksperiencë'
      }
    },
    services: {
      title: 'Shërbimet',
      titleHighlight: 'Tona',
      subtitle: 'Zgjidhje të plota dixhitale për të rritur biznesin tuaj',
      contentMarketing: {
        title: 'Content Marketing',
        description: 'Përmbajtje cilësore që tërheq, angazhon dhe konverton audiencën tuaj'
      },
      socialMedia: {
        title: 'Social Media Management',
        description: 'Strategji dhe menaxhim profesional i platformave sociale për rritjen e brandimit'
      },
      branding: {
        title: 'Branding & Design',
        description: 'Identitet vizual unik që dallon biznesin tuaj nga konkurrenca'
      },
      seo: {
        title: 'SEO & Analytics',
        description: 'Optimizim për motorët e kërkimit dhe analiza të detajuara të performancës'
      },
      video: {
        title: 'Video Production',
        description: 'Përmbajtje video profesionale për të gjitha platformat dixhitale'
      },
      advertising: {
        title: 'Digital Advertising',
        description: 'Fushata reklamuese të targetuara që maksimizojnë ROI-në tuaj'
      }
    },
    whyUs: {
      title: 'Pse të Zgjidhni',
      titleHighlight: 'Contenta.al',
      innovation: {
        title: 'Inovacion',
        description: 'Strategji kreative dhe zgjidhje moderne dixhitale'
      },
      results: {
        title: 'Rezultate',
        description: 'Focus në metrika dhe rritje të matshme'
      },
      support: {
        title: 'Mbështetje',
        description: 'Ekip i dedikuar për suksesin tuaj'
      },
      expertise: {
        title: 'Ekspertizë',
        description: 'Profesionistë me përvojë të gjërë në industri'
      }
    },
    portfolio: {
      title: 'Portfolio',
      titleHighlight: 'i Fundit',
      subtitle: 'Projekte që ne krenohemi t\'i kemi realizuar',
      viewAll: 'Shiko të Gjitha',
      viewProject: 'Shiko Projektin',
      categories: {
        all: 'Të Gjitha',
        branding: 'Branding',
        social: 'Social Media',
        video: 'Video',
        web: 'Web Design'
      }
    },
    testimonials: {
      title: 'Çfarë Thonë',
      titleHighlight: 'Klientët Tanë',
      subtitle: 'Dëgjoni nga bizneset që kanë transformuar praninë e tyre dixhitale me ne'
    },
    cta: {
      title: 'Gati për të Filluar',
      titleHighlight: 'Projektin Tuaj?',
      description: 'Kontaktoni sot dhe merrni një konsultim falas për strategjinë tuaj dixhitale',
      button: 'Kontaktoni Tani',
      phone: 'Ose na telefononi'
    },
    workflow: {
      title: 'Si',
      titleHighlight: 'Punojmë Ne',
      subtitle: 'Hap pas hapi, ja si i sjellim në jetë idetë tuaja',
      plan: {
        title: 'Planifikimi',
        description: 'Fillojmë duke kuptuar objektivat tuaja dhe duke hartuar një strategji të detajuar për projektin.'
      },
      design: {
        title: 'Dizajnimi',
        description: 'Krijojmë dizajne vizualisht tërheqëse dhe intuitive që reflektojnë identitetin e markës suaj.'
      },
      build: {
        title: 'Zhvillimi',
        description: 'Transformojmë dizajnet në website/aplikacione funksionale me teknologjitë më të fundit.'
      },
      launch: {
        title: 'Lansimi & Rritja',
        description: 'Publikojmë projektin tuaj dhe ju ndihmojmë të arrini audiencën me strategji marketingu.'
      },
      cta: 'Gati të filloni udhëtimin tuaj dixhital?',
      ctaButton: 'Filloni Projektin'
    },
    footer: {
      description: 'Transformojmë idetë tuaja në strategji dixhitale që sjellin rezultate të matshme.',
      company: 'Kompania',
      services: 'Shërbimet',
      contact: 'Kontakti',
      about: 'Rreth Nesh',
      portfolio: 'Portfolio',
      blog: 'Blog',
      newsletter: 'Newsletter',
      newsletterText: 'Merrni këshilla dhe oferta ekskluzive direkt në email',
      emailPlaceholder: 'Email juaj',
      subscribe: 'Abonohu',
      subscribing: 'Duke dërguar...',
      subscribeSuccess: 'Faleminderit për abonimin!',
      subscribeError: 'Dicka shkoi gabim. Provoni përsëri.',
      contentMarketing: 'Content Marketing',
      socialMedia: 'Social Media',
      branding: 'Branding & Design',
      seo: 'SEO & Analytics',
      rights: 'Të gjitha të drejtat e rezervuara.',
      made: 'Krijuar me profesionalizëm nga stafi i contenta.al'
    },
    reviews: {
      title: 'Çfarë Thonë',
      titleHighlight: 'Klientët Tanë',
      subtitle: 'Opinioni i klientëve tanë është më i rëndësishëm për ne',
      formTitle: 'Lini Review-n Tuaj',
      nameLabel: 'Emri Juaj',
      companyLabel: 'Kompania (opsionale)',
      ratingLabel: 'Vlerësimi',
      reviewLabel: 'Review-i Juaj',
      submitButton: 'Dërgo Review',
      submitting: 'Duke dërguar...',
      successMessage: 'Faleminderit! Review-i juaj u dërgua me sukses.',
      errorMessage: 'Dicka shkoi gabim. Ju lutem provoni përsëri.'
    },
    common: {
      readMore: 'Lexo Më Shumë',
      learnMore: 'Mëso Më Shumë',
      getStarted: 'Fillo Tani',
      contactUs: 'Na Kontaktoni',
      send: 'Dërgo',
      loading: 'Duke u ngarkuar...',
      success: 'Sukses!',
      error: 'Gabim!'
    },
    about: {
      title: 'Rreth',
      titleHighlight: 'Nesh',
      subtitle: 'Agjencia juaj e besuar për zgjidhje dixhitale - duke ndërtuar të ardhmen',
      story: 'Historia Jonë',
      mission: 'Misioni ynë është të ndihmojmë bizneset të rriten përmes strategjive dixhitale inovative që thyejnë kufijtë',
      values: 'Vlerat Tona',
      team: 'Ekipi Ynë'
    },
    contact: {
      title: 'Na',
      titleHighlight: 'Kontaktoni',
      subtitle: 'Jemi këtu për t\'ju ndihmuar me projektin tuaj',
      name: 'Emri',
      email: 'Email',
      message: 'Mesazhi',
      send: 'Dërgo Mesazh',
      info: 'Informacioni i Kontaktit'
    },
    blog: {
      title: 'Blog',
      titleHighlight: 'i Ri',
      subtitle: 'Këshilla, artikuj dhe trendet më të fundit në marketing dixhital',
      comingSoon: 'Artikujt po vijnë së shpejti',
      stayTuned: 'Po përgatisim përmbajtje të vlefshme. Qëndroni të sintonizuar!'
    },
    portfolioPage: {
      title: 'Portfolio',
      titleHighlight: 'Ynë',
      subtitle: 'Eksploroni projektet tona të suksesshme',
      comingSoon: 'Galeria po vjen së shpejti',
      preparing: 'Po përgatisim punën tonë më të mirë. Qëndroni të sintonizuar!'
    }
  },
  en: {
    seo: {
      home: {
        title: 'Professional Digital Marketing Agency',
        description: 'Contenta Marketing - We transform your ideas into digital strategies that deliver results. Web Development, Social Media, Content Creation and Logo Design in Albania.',
        keywords: 'digital marketing, social media marketing, web development, content creation, logo design, marketing agency, albania'
      },
      about: {
        title: 'About Us - Our Story',
        description: 'Get to know Contenta Marketing - the new digital marketing agency launched in 2026 bringing freshness and professionalism to the Albanian market.',
        keywords: 'about us, contenta marketing, marketing agency, albania, professional marketing'
      },
      services: {
        title: 'Our Services',
        description: 'We offer Web Development, Social Media Management, Content Creation and Logo Design. Professional solutions for your digital business.',
        keywords: 'web development, social media management, content creation, logo design, marketing services, graphic design'
      },
      portfolio: {
        title: 'Portfolio - Our Projects',
        description: 'View our successful projects. Websites and digital campaigns we have created for our clients.',
        keywords: 'portfolio, web projects, website, web design'
      },
      blog: {
        title: 'Blog - Articles and Tips',
        description: 'Read our articles about digital marketing, social media, SEO and business growth strategies.',
        keywords: 'marketing blog, marketing articles, social media tips, seo tips, business strategy'
      },
      contact: {
        title: 'Contact Us',
        description: 'Get in touch with Contenta Marketing for a free consultation. WhatsApp, Email or phone - we are here to help you.',
        keywords: 'contact, free consultation, contenta marketing albania, phone, email, whatsapp'
      }
    },
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      portfolio: 'Portfolio',
      blog: 'Blog',
      contact: 'Contact',
      getStarted: 'Get Started'
    },
    hero: {
      title: 'We Transform',
      titleHighlight: 'Your Ideas',
      subtitle: 'into Digital Strategies that Drive Results',
      description: 'Your digital marketing agency that combines creativity with data analysis to grow your brand in the Albanian and international market.',
      cta: 'Free Consultation',
      learnMore: 'View Services',
      stats: {
        projects: 'Successful Projects',
        clients: 'Happy Clients',
        growth: 'Average Growth',
        experience: 'Years Experience'
      }
    },
    services: {
      title: 'Our',
      titleHighlight: 'Services',
      subtitle: 'Complete digital solutions to grow your business',
      contentMarketing: {
        title: 'Content Marketing',
        description: 'Quality content that attracts, engages and converts your audience'
      },
      socialMedia: {
        title: 'Social Media Management',
        description: 'Professional strategy and management of social platforms for brand growth'
      },
      branding: {
        title: 'Branding & Design',
        description: 'Unique visual identity that sets your business apart from competition'
      },
      seo: {
        title: 'SEO & Analytics',
        description: 'Search engine optimization and detailed performance analytics'
      },
      video: {
        title: 'Video Production',
        description: 'Professional video content for all digital platforms'
      },
      advertising: {
        title: 'Digital Advertising',
        description: 'Targeted advertising campaigns that maximize your ROI'
      }
    },
    whyUs: {
      title: 'Why Choose',
      titleHighlight: 'Contenta.al',
      innovation: {
        title: 'Innovation',
        description: 'Creative strategies and modern digital solutions'
      },
      results: {
        title: 'Results',
        description: 'Focus on metrics and measurable growth'
      },
      support: {
        title: 'Support',
        description: 'Dedicated team for your success'
      },
      expertise: {
        title: 'Expertise',
        description: 'Professionals with extensive industry experience'
      }
    },
    portfolio: {
      title: 'Latest',
      titleHighlight: 'Portfolio',
      subtitle: 'Projects we are proud to have delivered',
      viewAll: 'View All',
      viewProject: 'View Project',
      categories: {
        all: 'All',
        branding: 'Branding',
        social: 'Social Media',
        video: 'Video',
        web: 'Web Design'
      }
    },
    testimonials: {
      title: 'What Our',
      titleHighlight: 'Clients Say',
      subtitle: 'Hear from businesses that have transformed their digital presence with us'
    },
    cta: {
      title: 'Ready to Start',
      titleHighlight: 'Your Project?',
      description: 'Contact us today and get a free consultation for your digital strategy',
      button: 'Contact Now',
      phone: 'Or call us'
    },
    workflow: {
      title: 'How',
      titleHighlight: 'We Work',
      subtitle: "Step by step, here's how we bring your ideas to life",
      plan: {
        title: 'Plan',
        description: 'We start by understanding your goals and mapping out a detailed strategy for the project.'
      },
      design: {
        title: 'Design',
        description: 'We create visually appealing and intuitive designs that reflect your brand identity.'
      },
      build: {
        title: 'Build',
        description: 'We transform designs into functional websites/apps using the latest technologies.'
      },
      launch: {
        title: 'Launch & Grow',
        description: 'We publish your project and help you reach your audience with marketing strategies.'
      },
      cta: 'Ready to start your digital journey?',
      ctaButton: 'Start Your Project'
    },
    footer: {
      description: 'We transform your ideas into digital strategies that deliver measurable results.',
      company: 'Company',
      services: 'Services',
      contact: 'Contact',
      about: 'About Us',
      portfolio: 'Portfolio',
      blog: 'Blog',
      newsletter: 'Newsletter',
      newsletterText: 'Get exclusive tips and offers directly to your email',
      emailPlaceholder: 'Your email',
      subscribe: 'Subscribe',
      subscribing: 'Subscribing...',
      subscribeSuccess: 'Thank you for subscribing!',
      subscribeError: 'Something went wrong. Try again.',
      contentMarketing: 'Content Marketing',
      socialMedia: 'Social Media',
      branding: 'Branding & Design',
      seo: 'SEO & Analytics',
      rights: 'All rights reserved.',
      made: 'Created with professionalism by contenta.al staff'
    },
    reviews: {
      title: 'What Our',
      titleHighlight: 'Clients Say',
      subtitle: 'Our clients\' opinions matter most to us',
      formTitle: 'Leave Your Review',
      nameLabel: 'Your Name',
      companyLabel: 'Company (optional)',
      ratingLabel: 'Rating',
      reviewLabel: 'Your Review',
      submitButton: 'Submit Review',
      submitting: 'Submitting...',
      successMessage: 'Thank you! Your review was submitted successfully.',
      errorMessage: 'Something went wrong. Please try again.'
    },
    common: {
      readMore: 'Read More',
      learnMore: 'Learn More',
      getStarted: 'Get Started',
      contactUs: 'Contact Us',
      send: 'Send',
      loading: 'Loading...',
      success: 'Success!',
      error: 'Error!'
    },
    about: {
      title: 'About',
      titleHighlight: 'Us',
      subtitle: 'Your trusted agency for digital solutions - building the future',
      story: 'Our Story',
      mission: 'Our mission is to help businesses grow through innovative digital strategies that break boundaries',
      values: 'Our Values',
      team: 'Our Team'
    },
    contact: {
      title: 'Contact',
      titleHighlight: 'Us',
      subtitle: 'We\'re here to help with your project',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      send: 'Send Message',
      info: 'Contact Information'
    },
    blog: {
      title: 'Latest',
      titleHighlight: 'Blog',
      subtitle: 'Tips, articles and latest trends in digital marketing',
      comingSoon: 'Blog posts coming soon',
      stayTuned: 'We\'re preparing valuable content. Stay tuned!'
    },
    portfolioPage: {
      title: 'Our',
      titleHighlight: 'Portfolio',
      subtitle: 'Explore our successful projects',
      comingSoon: 'Gallery coming soon',
      preparing: 'We\'re curating our best work. Stay tuned!'
    }
  }
}
